import { useEffect, useState } from "react";
import { Button, Col, Form, Input, InputNumber, Modal, Row, Select, Switch } from "antd";
import { showNotificationTopEnd } from "../../../../util/utils";
import { DASHBOARD_PHONES, GENERAL } from "../../../../constants/AppConstants";


const { Option } = Select;

export default function PhonesModalForm(props) {
    const { visible, onClose, initialValues = null, onSubmit } = props;
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const isEdit = Boolean(initialValues);


    useEffect(() => {
        if (visible) {
            form.resetFields();
            if (isEdit) {
                form.setFieldsValue(initialValues);
            }
        }
    }, [visible, initialValues, isEdit, form]);


    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);

            const response = await onSubmit(values);
            if (response?.status === 200) {
                form.resetFields();
                onClose();
                showNotificationTopEnd("success", isEdit ? "Telefono actualizado" : "Telefono agregado");
            } else {
                showNotificationTopEnd("error", response?.data?.message || "Error al guardar");
            }
        } catch (error) {
            console.log("Errores de validación:", error);
        } finally {
            setLoading(false);
        }
    };


    return (
        <Modal
            title={
                isEdit
                    ? DASHBOARD_PHONES.ACTIONS.TOOLTIPS.EDIT +
                    GENERAL.SPACE +
                    DASHBOARD_PHONES.TITLE_SIMPLE
                    : DASHBOARD_PHONES.ACTIONS.TOOLTIPS.ADD +
                    GENERAL.SPACE +
                    DASHBOARD_PHONES.TITLE_SIMPLE
            }
            open={visible}
            onCancel={onClose}
            footer={null}
            destroyOnHidden
        >
            <Form form={form} layout="vertical" initialValues={{ active: true, main: false }}>
                <Row>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item label="ID" name="phoneId">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_PHONES.COLUMNS.OWNER_NAME}
                            name="ownerName"
                            rules={[{ required: true, message: "Nombre requerido" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_PHONES.COLUMNS.LADA}
                            name="lada"
                            rules={[{ required: true, message: "Lada requerida" }]}
                        >
                            <Select>
                                <Option value="52">+ 52</Option>
                                <Option value="1">+ 1</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_PHONES.COLUMNS.PHONE}
                            name="phoneNumber"
                            rules={[{ required: true, message: "Telefono requerido" },
                            { pattern: /^\d{10}$/, message: "El teléfono debe contener exactamente 10 dígitos" }]}
                        >
                            <InputNumber style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={24}>
                        <Form.Item
                            label={DASHBOARD_PHONES.COLUMNS.WHATSAPP_PHONE_ID}
                            name="whatsAppPhoneId"
                            rules={[{ required: true, message: "ID de WhatsApp requerido" }]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_PHONES.COLUMNS.MAIN}
                            valuePropName="checked"
                            name="main"
                        >
                            <Switch
                                checkedChildren="Principal"
                                unCheckedChildren="Secundario"
                            />
                        </Form.Item>
                    </Col>
                    <Col className="px-5" xs={24} sm={24} md={12}>
                        <Form.Item
                            label={DASHBOARD_PHONES.COLUMNS.STATUS}
                            valuePropName="checked"
                            name="active"
                        >
                            <Switch
                                checkedChildren="Activo"
                                unCheckedChildren="Inactivo"
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Button type="primary" onClick={handleSubmit} loading={loading} block>
                        {isEdit
                            ? DASHBOARD_PHONES.ACTIONS.TOOLTIPS.UPDATE
                            : DASHBOARD_PHONES.ACTIONS.TOOLTIPS.SAVE}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
}